/** A file must have been chosen: `null` fails. */
function isImportFileSelected(value: File | null): boolean {
	return value !== null;
}

export default isImportFileSelected;
